export default __webpack_public_path__ + "static/media/angpao.a6fbb1cd.webp";